'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AssetCategoriesBar = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(AssetCategoriesBar, _React$Component);

  function AssetCategoriesBar() {
    (0, _classCallCheck3.default)(this, AssetCategoriesBar);
    return (0, _possibleConstructorReturn3.default)(this, (AssetCategoriesBar.__proto__ || (0, _getPrototypeOf2.default)(AssetCategoriesBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(AssetCategoriesBar, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          type = _props.type,
          sticky = _props.sticky;


      var styles = require('./AssetCategoriesBar.scss');

      var categories = this.props.categories || [];
      categories = categories && (Array.isArray(categories) ? categories : [categories]);

      var allCategory = _react2.default.createElement(
        'li',
        { className: styles.AssetCategory },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/types/' + type, className: styles['AssetCategory-wrap'], activeClassName: styles['AssetCategory-wrap--active'] },
          _react2.default.createElement(
            'span',
            null,
            'All'
          )
        )
      );

      var componentClasses = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.AssetCategoriesBar, true), (0, _defineProperty3.default)(_classnames, styles['AssetCategoriesBar--sticky'], sticky), _classnames));

      return _react2.default.createElement(
        'ul',
        { className: componentClasses },
        allCategory,
        categories.map(function (category) {
          var categoryElement = void 0;

          if (!category.hidden) {
            var rightArrow = category.hasChildren ? _react2.default.createElement('i', { className: 'fa fa-angle-right' }) : undefined;

            categoryElement = _react2.default.createElement(
              'li',
              { className: styles.AssetCategory },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/types/' + type + '/categories/' + category.slug, className: styles['AssetCategory-wrap'], activeClassName: styles['AssetCategory-wrap--active'] },
                _react2.default.createElement(
                  'span',
                  null,
                  category.name
                ),
                rightArrow
              )
            );
          }

          return { categoryElement: categoryElement };
        })
      );
    }
  }]);
  return AssetCategoriesBar;
}(_react2.default.Component), _class.propTypes = {
  categories: _react2.default.PropTypes.array
}, _temp);

// <Link
//                   to="categories"
//                   params={
//                     {
//                       type: this.props.type,
//                       categories: this.props.parents.concat(category.slug) }
//                     }
//                   className={styles['AssetCategory-wrap']}
//                   activeClassName={styles['AssetCategory-wrap--active']}
//                 >
//                   <span>{category.name}</span>
//                   {rightArrow}
//                 </Link>

exports.default = AssetCategoriesBar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AssetCategoriesBar/AssetCategoriesBar.jsx
// module id = 2416
// module chunks = 0